export default "__VITE_ASSET__CHQrh$6e__"